class HeaderModel {

    id: number | null;
    text: string | null;
    align: string | null;
    sortable: boolean | null;
    value: string | null;
    width?: string | null;
    class?: string | null;

    constructor(id: number, text: string, align: string,
                sortable: boolean, value: string, width?:
                    string, classStyle?: string) {
        this.id = id;
        this.text = text;
        this.align = align;
        this.sortable = sortable;
        this.value = value;
        this.width = width;
        this.class = classStyle;
    }
}

export default HeaderModel;
